import DropDownButton from "components/DropDownButton/DropDownButton";
import { Row, TitleView } from "components/styles";
import { RESOURCE_MODULE_TITLES } from "views/Recursos/utils/constants";

const Superheader = ({
    resourceTypes,
    openShowDialogResourceForm
}) => {
    const getPropsToDropdownButton = () => {
        return {
            text: "Registrar recurso",
            items: resourceTypes.map(({ id, name }) => ({
                text: name,
                onClick: () => openShowDialogResourceForm({
                    resourceTypeId: id,
                    resource: null
                })
            }))
        };
    }
    return (
        <Row>
            <TitleView>{RESOURCE_MODULE_TITLES.LIBRARY}</TitleView>
            <DropDownButton 
                {...getPropsToDropdownButton()}
                itemSize="medium"/>
        </Row>
    );
}

export default Superheader;